export const INPUT_NO_ELEMENT_SYSNAME = 'I_INPUT_PORT_NO';
export const DATE_FILTER_ELEMENT_SYSNAME = 'DATE_FILTER'; // Not yet create on the database. Future task
export const TIME_FILTER_ELEMENT_SYSNAME = 'TIME_FILTER'; // Not yet create on the database. Future task
export const REPORTS_FILTER_DATE_TIME_SPECIFIC_DATE ="REPORTS_FILTER_DATE_TIME_SPECIFIC_DATE";
export const REPORTS_FILTER_DATE_TIME_DATE_RANGE ="REPORTS_FILTER_DATE_TIME_DATE_RANGE";
export const REPORTS_FILTER_DATE_TIME_CURRENT_MONTH ="REPORTS_FILTER_DATE_TIME_CURRENT_MONTH";
export const REPORTS_FILTER_DATE_TIME_CURRENT_WEEK ="REPORTS_FILTER_DATE_TIME_CURRENT_WEEK";
export const REPORTS_FILTER_DATE_TIME_LAST_TWO_WEEKS ="REPORTS_FILTER_DATE_TIME_LAST_TWO_WEEKS";
export const REPORTS_FILTER_DATE_TIME_LAST_THREE_DAYS ="REPORTS_FILTER_DATE_TIME_LAST_THREE_DAYS";
export const REPORTS_FILTER_DATE_TIME_LAST_FOUR_WEEKS ="REPORTS_FILTER_DATE_TIME_LAST_FOUR_WEEKS";
export const REPORTS_FILTER_DATE_TIME_LAST_SIX_MONTHS ="REPORTS_FILTER_DATE_TIME_LAST_SIX_MONTHS";
export const REPORTS_FILTER_DATE_TIME_LAST_MONTH ="REPORTS_FILTER_DATE_TIME_LAST_MONTH";
export const REPORTS_FILTER_DATE_TIME_LAST_WEEK ="REPORTS_FILTER_DATE_TIME_LAST_WEEK";
export const REPORTS_FILTER_DATE_TIME_LAST_YEAR ="REPORTS_FILTER_DATE_TIME_LAST_YEAR";
export const REPORTS_FILTER_DATE_TIME_TODAY ="REPORTS_FILTER_DATE_TIME_TODAY";
export const REPORTS_FILTER_DATE_TIME_YESTERDAY ="REPORTS_FILTER_DATE_TIME_YESTERDAY";
export const INPUT_IP_ELEMENT_SYSNAME = 'G_BACKGROUND_INFO';
export const REPORTS_FILTER_TIME = 'FILTER_TIME';
export const STATIC_DATE_ELEMENT: string[] = [
    REPORTS_FILTER_DATE_TIME_CURRENT_MONTH,
    REPORTS_FILTER_DATE_TIME_CURRENT_WEEK,
    REPORTS_FILTER_DATE_TIME_LAST_TWO_WEEKS,
    REPORTS_FILTER_DATE_TIME_LAST_THREE_DAYS,
    REPORTS_FILTER_DATE_TIME_LAST_FOUR_WEEKS,
    REPORTS_FILTER_DATE_TIME_LAST_SIX_MONTHS,
    REPORTS_FILTER_DATE_TIME_LAST_MONTH,
    REPORTS_FILTER_DATE_TIME_LAST_WEEK,
    REPORTS_FILTER_DATE_TIME_LAST_YEAR,
    REPORTS_FILTER_DATE_TIME_TODAY,
    REPORTS_FILTER_DATE_TIME_YESTERDAY
];
export const MOB_STID_ENABLED: string = "MOB_STID_ENABLED";
export const MOB_STID_CARD_TOGGLE: string = "MOB_STID_CARD_TOGGLE";
export const MOB_STID_CARD_DISTANCE: string = "MOB_STID_CARD_DISTANCE";
export const MOB_STID_HANDS_FREE_TOGGLE: string = "MOB_STID_HANDS_FREE_TOGGLE";
export const MOB_STID_HANDS_FREE_DISTANCE: string = "MOB_STID_HANDS_FREE_DISTANCE";
export const MOB_STID_TAP_TAP_TOGGLE: string = "MOB_STID_TAP_TAP_TOGGLE";
export const MOB_STID_TAP_TAP_DISTANCE: string = "MOB_STID_TAP_TAP_DISTANCE";
export const MOB_STID_REMOTE_TOGGLE: string = "MOB_STID_REMOTE_TOGGLE";
export const MOB_STID_REMOTE_DISTANCE: string = "MOB_STID_REMOTE_DISTANCE";
export const MOB_STID_SMART_UNLOCK: string = "MOB_STID_SMART_UNLOCK";
export const MOB_STID_VCARD_NUM_BYTES: string = "MOB_STID_VCARD_NUM_BYTES";
export const MOB_STID_VCARD_OFFSET: string = "MOB_STID_VCARD_OFFSET";
export const MOB_STID_REVERSE_BYTES: string = "MOB_STID_REVERSE_BYTES";
export const MOB_STID_BLE_NFC: string = "MOB_STID_BLE_NFC";
export const MOB_TX_POWER: string = "MOB_TX_POWER";
export const MOB_STID_REMOTE_BUTTON: string = "MOB_STID_REMOTE_BUTTON";
export const MOB_STID_SITE_CODE: string = "MOB_STID_SITE_CODE";
export const MOB_STID_SITE_CODE_TYPE: string = "MOB_STID_SITE_CODE_TYPE";
export const MOB_HID_ENABLED: string = "MOB_HID_ENABLED";
export const MOB_HID_TWIST_TOGGLE: string = "MOB_HID_TWIST_TOGGLE";
export const MOB_HID_TWIST_RSSI: string = "MOB_HID_TWIST_RSSI";
export const MOB_HID_TAP_TOGGLE: string = "MOB_HID_TAP_TOGGLE";
export const MOB_HID_TAP_RSSI: string = "MOB_HID_TAP_RSSI";
export const MOB_HID_REMOTE_TOGGLE: string = "MOB_HID_REMOTE_TOGGLE";
export const MOB_HID_REMOTE_RSSI: string = "MOB_HID_REMOTE_RSSI";
export const MOB_HID_REVERSE_BYTES: string = "MOB_HID_REVERSE_BYTES";